<template>
  <loading :active="allPageLoading"
          :can-cancel="true"
          :on-cancel="onCancel"
          :is-full-page="true"
          :color="'#fff'"
          :background-color="'#000'"
          :opacity="'0.8'"
          :loader=" dots">
  </loading>
  <header class="flex justify-between items-center py-2 px-2 bg-white">
    <div class="lg:flex md:block sm:block items-center">
      <div class="relative mx-4 lg:mx-0 border-r px-8">
        {{ title }}
      </div>
      <slot></slot>
    </div>

    <div class="flex items-center">
      <div v-if="editPage" class="relative">
        <div class="pr-4 pb-1 cursor-pointer" @click="showDialog = ! showDialog">
          <svg :fill="showDialog ? '#97C7FA' : '#D1D5DB'" height="25px" width="25px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 236.108 236.108" xml:space="preserve" :stroke="showDialog ? '#97C7FA' : '#D1D5DB'">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier"> 
              <g> 
                <path d="M7.5,69.21c-4.142,0-7.5,3.358-7.5,7.5v58.54c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5V76.71 C15,72.568,11.642,69.21,7.5,69.21z"></path> 
                <path d="M166.428,25.459h-31.204c-4.142,0-7.5,3.358-7.5,7.5v6.775L27.289,69.517c-3.184,0.944-5.368,3.87-5.368,7.19v58.512 c-0.002,0.375,0.034,0.753,0.09,1.132c0.01,0.07,0.02,0.14,0.032,0.209c0.056,0.31,0.124,0.62,0.221,0.928l21.261,67.9 c1.004,3.207,3.963,5.261,7.155,5.261c0.741,0,1.495-0.111,2.24-0.344l30.961-9.681c1.899-0.594,3.484-1.918,4.406-3.68 c0.923-1.762,1.107-3.819,0.513-5.718l-10.536-33.669l49.459,14.67v6.774c0,4.142,3.358,7.5,7.5,7.5h31.204 c4.142,0,7.5-3.358,7.5-7.5V32.959C173.928,28.817,170.57,25.459,166.428,25.459z M72.245,188.546l-16.646,5.205l-14.814-47.311 l20.154,5.977L72.245,188.546z M69.078,139.187c-0.021-0.006-0.043-0.013-0.064-0.019l-32.092-9.519V82.306l90.803-26.926v101.202 L69.078,139.187z M158.928,171.502h-16.204v-4.873V45.333v-4.873h16.204V171.502z"></path> 
                <path d="M224.962,147.969l-32.452-16.229c-3.706-1.851-8.21-0.352-10.063,3.354c-1.853,3.705-0.351,8.21,3.354,10.063 l32.452,16.229c1.077,0.539,2.221,0.793,3.349,0.793c2.751,0,5.4-1.519,6.714-4.147 C230.168,154.327,228.666,149.822,224.962,147.969z"></path> 
                <path d="M189.161,81.012c1.127,0,2.272-0.255,3.348-0.794l32.453-16.227c3.705-1.853,5.207-6.357,3.354-10.062 c-1.852-3.705-6.358-5.207-10.062-3.354l-32.453,16.227c-3.705,1.853-5.207,6.357-3.354,10.062 C183.761,79.493,186.41,81.012,189.161,81.012z"></path> 
                <path d="M228.608,98.48h-27.098c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h27.098c4.142,0,7.5-3.358,7.5-7.5 C236.108,101.837,232.75,98.48,228.608,98.48z"></path> 
              </g> 
            </g>
          </svg>
        </div>

        <div v-show="showDialog"
          class="absolute right-0 mt-2 p-2 bg-white rounded-md shadow-xl overflow-y-auto h-36 z-10"
          style="width: 22.25rem;">
          <div class="px-2 py-4 text-sm bg-white rounded-lg max-w-2xl mx-auto text-gray-800">
            <div class="flex">
              <div class="mb-4">
                <p class="font-bold text-primary mb-2">投遞概況描述</p>
                <p class="text-gray-500">目前廣告尚處於投遞初期的學習期階段，系統正針對不同受眾群與版位進行 A/B 測試，以找出最佳投遞組合。初步數據顯示，行動裝置用戶點擊率較高，但轉換率尚未穩定。現階段平均 CPC 為 NT$8.1，CPA 則約落在 NT$240，仍有優化空間。後續系統將逐步排除低互動的廣告組合，並集中資源於高表現版位。投遞策略將轉向以轉換優化（oCPA）為主，逐步壓低 CPA 並提升 ROAS（廣告投資報酬率）。</p>
              </div>
            </div>

            <div class="flex border-t pt-4">
              <div class="mb-4">
                <p class="font-bold text-primary mb-2">建議策略</p>
                <div class="space-y-2 text-gray-500">
                  <label class="flex items-center space-x-2">
                    <input type="radio" name="strategy" value="keep" class="accent-primary" checked>
                    <span>維持目前策略</span>
                  </label>
                  <label class="flex items-center space-x-2">
                    <input type="radio" name="strategy" value="clicks" class="accent-primary">
                    <span>優化點擊率</span>
                  </label>
                  <label class="flex items-center space-x-2">
                    <input type="radio" name="strategy" value="reach" class="accent-primary">
                    <span>提高觸及人數</span>
                  </label>
                </div>
              </div>
            </div>

            <div class="border-t text-right pt-4">
              <button type="submit" class="bg-green-500 text-white px-2 py-1 rounded">
                確定
              </button>
            </div>
          </div>
        </div>

        <!-- <Dialog :visible="showDialog">
          <template #header>
            <h2 class="text-xl font-semibold">投遞概況</h2>
          </template>

          <div class="p-6 bg-white rounded-lg shadow-md max-w-2xl mx-auto text-gray-800">
            <div class="flex space-x-4 border-t pt-4">
              <div class="mb-4">
                <p class="text-lg font-bold text-primary mb-2">概況描述</p>
                <p class="text-gray-500">目前廣告尚處於投遞初期的學習期階段，系統正針對不同受眾群與版位進行 A/B 測試，以找出最佳投遞組合。初步數據顯示，行動裝置用戶點擊率較高，但轉換率尚未穩定。現階段平均 CPC 為 NT$8.1，CPA 則約落在 NT$240，仍有優化空間。後續系統將逐步排除低互動的廣告組合，並集中資源於高表現版位。投遞策略將轉向以轉換優化（oCPA）為主，逐步壓低 CPA 並提升 ROAS（廣告投資報酬率）。</p>
              </div>
            </div>

            <div class="flex space-x-4 border-t pt-4">
              <div class="mb-8">
                <p class="text-lg font-bold text-primary mb-2">建議策略</p>
                <div class="space-y-2 text-gray-500">
                  <label class="flex items-center space-x-2">
                    <input type="radio" name="strategy" value="keep" class="accent-primary" checked>
                    <span>維持目前策略</span>
                  </label>
                  <label class="flex items-center space-x-2">
                    <input type="radio" name="strategy" value="clicks" class="accent-primary">
                    <span>優化點擊率</span>
                  </label>
                  <label class="flex items-center space-x-2">
                    <input type="radio" name="strategy" value="reach" class="accent-primary">
                    <span>提高觸及人數</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <template #footer>
            <button type="submit" class="bg-green-500 text-white px-2 py-1 rounded">
              確定
            </button>
            <button @click="showDialog = false" class="bg-gray-200 text-gray-700 px-2 py-1 rounded ml-1">
              關閉
            </button>
          </template>
        </Dialog> -->
      </div>

      <div v-if="reportPage" class="relative">
        <div class="pr-4 pb-1 cursor-pointer" @click="showReportDialog = ! showReportDialog">
          <svg :fill="showReportDialog ? '#97C7FA' : '#D1D5DB'" height="25px" width="25px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 236.108 236.108" xml:space="preserve" :stroke="showReportDialog ? '#97C7FA' : '#D1D5DB'">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier"> 
              <g> 
                <path d="M7.5,69.21c-4.142,0-7.5,3.358-7.5,7.5v58.54c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5V76.71 C15,72.568,11.642,69.21,7.5,69.21z"></path> 
                <path d="M166.428,25.459h-31.204c-4.142,0-7.5,3.358-7.5,7.5v6.775L27.289,69.517c-3.184,0.944-5.368,3.87-5.368,7.19v58.512 c-0.002,0.375,0.034,0.753,0.09,1.132c0.01,0.07,0.02,0.14,0.032,0.209c0.056,0.31,0.124,0.62,0.221,0.928l21.261,67.9 c1.004,3.207,3.963,5.261,7.155,5.261c0.741,0,1.495-0.111,2.24-0.344l30.961-9.681c1.899-0.594,3.484-1.918,4.406-3.68 c0.923-1.762,1.107-3.819,0.513-5.718l-10.536-33.669l49.459,14.67v6.774c0,4.142,3.358,7.5,7.5,7.5h31.204 c4.142,0,7.5-3.358,7.5-7.5V32.959C173.928,28.817,170.57,25.459,166.428,25.459z M72.245,188.546l-16.646,5.205l-14.814-47.311 l20.154,5.977L72.245,188.546z M69.078,139.187c-0.021-0.006-0.043-0.013-0.064-0.019l-32.092-9.519V82.306l90.803-26.926v101.202 L69.078,139.187z M158.928,171.502h-16.204v-4.873V45.333v-4.873h16.204V171.502z"></path> 
                <path d="M224.962,147.969l-32.452-16.229c-3.706-1.851-8.21-0.352-10.063,3.354c-1.853,3.705-0.351,8.21,3.354,10.063 l32.452,16.229c1.077,0.539,2.221,0.793,3.349,0.793c2.751,0,5.4-1.519,6.714-4.147 C230.168,154.327,228.666,149.822,224.962,147.969z"></path> 
                <path d="M189.161,81.012c1.127,0,2.272-0.255,3.348-0.794l32.453-16.227c3.705-1.853,5.207-6.357,3.354-10.062 c-1.852-3.705-6.358-5.207-10.062-3.354l-32.453,16.227c-3.705,1.853-5.207,6.357-3.354,10.062 C183.761,79.493,186.41,81.012,189.161,81.012z"></path> 
                <path d="M228.608,98.48h-27.098c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h27.098c4.142,0,7.5-3.358,7.5-7.5 C236.108,101.837,232.75,98.48,228.608,98.48z"></path> 
              </g> 
            </g>
          </svg>
        </div>

        <Dialog :visible="showReportDialog">
          <template #header>
            <h2 class="text-xl font-semibold">投遞概況</h2>
          </template>

          <div class="p-6 bg-white rounded-lg shadow-md max-w-2xl mx-auto text-gray-800">
            <h4 class="text-lg font-bold text-primary mb-2">行銷活動設定</h4>

            <div class="space-y-3 mb-6 text-sm overflow-y-auto" style="height:300px;">
              <div class="grid grid-cols-12 gap-2">
                <div class="col-span-3 text-right">行銷活動名稱：</div>
                <div class="col-span-9">123456</div>
                <div class="col-span-3 text-right">行銷方式（USD）：</div>
                <div class="col-span-9">精準興趣：10</div>
                <div class="col-span-3 text-right">受益者：</div>
                <div class="col-span-9">PapL（123456）</div>
                <div class="col-span-3 text-right">出資者：</div>
                <div class="col-span-9">PapL（123456）</div>
                <div class="col-span-3 text-right">精準興趣：</div>
                <div class="col-span-9 flex flex-wrap">
                  <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                    廣告1
                  </div>
                  <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                    廣告2
                  </div>
                  <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                    廣告3
                  </div>
                  <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                    廣告4
                  </div>
                  <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                    廣告5
                  </div>
                </div>
                <div class="col-span-3 text-right">類似受眾：</div>
                <div class="col-span-9 flex flex-wrap">
                  <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                    廣告1111111111111111111111111
                  </div>
                  <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                    廣告22222222222222222222222
                  </div>
                  <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                    廣告3444444444444444444444444444444
                  </div>
                  <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                    廣告4555555555555555555555555555555
                  </div>
                  <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                    廣告56666666666666666666666666
                  </div>
                </div>
                <div class="col-span-3 text-right">類似受眾-推廣網址：</div>
                <div class="col-span-9">
                  https://www.autoturn.net/index.php/index/view
                </div>
                <div class="col-span-3 text-right">再行銷：</div>
                <div class="col-span-9 flex flex-wrap">
                  <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                    廣告1
                  </div>
                  <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                    廣告2
                  </div>
                  <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                    廣告3
                  </div>
                  <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                    廣告4
                  </div>
                  <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                    廣告5
                  </div>
                </div>
                <div class="col-span-3 text-right">行銷日期：</div>
                <div class="col-span-9">2025-06-07 - 0000-00-00</div>
                <div class="col-span-3 text-right">目標：</div>
                <div class="col-span-9">轉換次數：購買 - 未來實驗室的像素 - 轉換次數</div>
                <div class="col-span-3 text-right">轉換網域：</div>
                <div class="col-span-9">autoturn.net</div>
                <div class="col-span-3 text-right">目錄銷售-商品組合：</div>
                <div class="col-span-9">商品組合名稱</div>
                <div class="col-span-3 text-right">目錄銷售-事件：</div>
                <div class="col-span-9">購買 - 未來實驗室的像素</div>
                <div class="col-span-3 text-right">應用程式事件：</div>
                <div class="col-span-9">無</div>
                <div class="col-span-3 text-right">目標成本（USD）：</div>
                <div class="col-span-9">10</div>
                <div class="col-span-3 text-right">預算使用：</div>
                <div class="col-span-9">穩健 - 依照成效好壞時下修廣告組合預算，不會超過總預算</div>
                <div class="col-span-3 text-right">預算比率：</div>
                <div class="col-span-9">10 %</div>
                <div class="col-span-3 text-right">地點：</div>
                <div class="col-span-9">台灣</div>
                <div class="col-span-3 text-right">語言：</div>
                <div class="col-span-9">所有語言</div>
                <div class="col-span-3 text-right">性別：</div>
                <div class="col-span-9">全部性別</div>
                <div class="col-span-3 text-right">年齡：</div>
                <div class="col-span-9">18 ~ 65</div>
                <div class="col-span-3 text-right">關係鏈與受眾：</div>
                <div class="col-span-9">無</div>
                <div class="col-span-3 text-right">裝置：</div>
                <div class="col-span-9">桌上型電腦、行動裝置</div>
                <div class="col-span-3 text-right">平台：</div>
                <div class="col-span-9">Faecbook、Instagram、Audience Network、Messenger</div>
                <div class="col-span-3 text-right">特定行動裝置和作業系統：</div>
                <div class="col-span-9">所有行動裝置</div>
                <div class="col-span-3 text-right">身份-Facebook：</div>
                <div class="col-span-9">Autoturn</div>
                <div class="col-span-3 text-right">身份-Instagram：</div>
                <div class="col-span-9">使用所選的粉絲專頁</div>
                <div class="col-span-3 text-right">素材內容：</div>
                <div class="col-span-9 flex flex-col space-y-2 h-96 overflow-y-auto">
                  <div v-tippy="tooltipOptions" class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group">
                    <div class="relative flex justify-between p-1">
                      <div class="md:flex-shrink-0">
                        <img class="h-24 w-24 rounded-xl object-cover" src="https://scontent-nrt1-1.xx.fbcdn.net/v/t15.5256-10/469018299_2099756487132679_8282074920297271073_n.jpg?stp=dst-jpg_s130x130_tt6&amp;_nc_cat=109&amp;ccb=1-7&amp;_nc_sid=7965db&amp;_nc_ohc=W7OCKGYCh54Q7kNvwHym8RL&amp;_nc_oc=AdnEUR9t2-o4WBRnenA3fH7tg-I-LklVkhqGRRvMTkHGCk8mxL1ZPonHGDzn6JEoRw4&amp;_nc_zt=23&amp;_nc_ht=scontent-nrt1-1.xx&amp;edm=AJfPMC4EAAAA&amp;_nc_gid=FALIYAFCBVtgGnPYOPpL7A&amp;oh=00_AfMZp-Q1oPVRVsgHbvTIFLyoNVbG0Xb2WDgTT56Vh80hGw&amp;oe=68484BB9">
                      </div>
                      <div class="relative flex-grow flex flex-col px-2">
                        <p class="flex-none flex text-lg overflow-hidden">
                          <span style="width: 70%;">AI 加漏斗 讓投放更高效 更省時！...</span>
                          <span class="w-1/3 mr-4">FaceBook Post</span>
                        </p>
                        <p class="flex-grow text-gray-500 overflow-hidden">1108961467897381</p>
                        <div class="flex-none flex">
                          <img src="/img/great.a251d02f.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">24</span>
                          <img src="/img/heart.8fdcbfc4.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">1</span>
                          <img src="/img/smile.65142fbd.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">0</span>
                          <img src="/img/cry.6e25808e.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">0</span>
                          <img src="/img/shock.bdb7c0e5.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">0</span>
                          <img src="/img/angry.1c0ad48e.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">0</span>
                          <div class="flex-grow text-right text-gray-500">
                            <span>2024/12/04</span>
                          </div>
                        </div>
                      </div>
                      <i class="absolute top-2 right-2 pi pi-times cursor-pointer"></i>
                    </div>
                  </div>
                  <div v-tippy="tooltipOptions" class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group">
                    <div class="relative flex justify-between p-1">
                      <div class="md:flex-shrink-0">
                        <img class="h-24 w-24 rounded-xl object-cover" src="https://scontent-nrt1-1.xx.fbcdn.net/v/t15.5256-10/469018299_2099756487132679_8282074920297271073_n.jpg?stp=dst-jpg_s130x130_tt6&amp;_nc_cat=109&amp;ccb=1-7&amp;_nc_sid=7965db&amp;_nc_ohc=W7OCKGYCh54Q7kNvwHym8RL&amp;_nc_oc=AdnEUR9t2-o4WBRnenA3fH7tg-I-LklVkhqGRRvMTkHGCk8mxL1ZPonHGDzn6JEoRw4&amp;_nc_zt=23&amp;_nc_ht=scontent-nrt1-1.xx&amp;edm=AJfPMC4EAAAA&amp;_nc_gid=FALIYAFCBVtgGnPYOPpL7A&amp;oh=00_AfMZp-Q1oPVRVsgHbvTIFLyoNVbG0Xb2WDgTT56Vh80hGw&amp;oe=68484BB9">
                      </div>
                      <div class="relative flex-grow flex flex-col px-2">
                        <p class="flex-none flex text-lg overflow-hidden">
                          <span style="width: 70%;">AI 加漏斗 讓投放更高效 更省時！...</span>
                          <span class="w-1/3 mr-4">FaceBook Post</span>
                        </p>
                        <p class="flex-grow text-gray-500 overflow-hidden">1108961467897381</p>
                        <div class="flex-none flex">
                          <img src="/img/great.a251d02f.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">24</span>
                          <img src="/img/heart.8fdcbfc4.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">1</span>
                          <img src="/img/smile.65142fbd.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">0</span>
                          <img src="/img/cry.6e25808e.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">0</span>
                          <img src="/img/shock.bdb7c0e5.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">0</span>
                          <img src="/img/angry.1c0ad48e.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">0</span>
                          <div class="flex-grow text-right text-gray-500">
                            <span>2024/12/04</span>
                          </div>
                        </div>
                      </div>
                      <i class="absolute top-2 right-2 pi pi-times cursor-pointer"></i>
                    </div>
                  </div>
                  <div v-tippy="tooltipOptions" class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group">
                    <div class="relative flex justify-between p-1">
                      <div class="md:flex-shrink-0">
                        <img class="h-24 w-24 rounded-xl object-cover" src="https://scontent-nrt1-1.xx.fbcdn.net/v/t15.5256-10/469018299_2099756487132679_8282074920297271073_n.jpg?stp=dst-jpg_s130x130_tt6&amp;_nc_cat=109&amp;ccb=1-7&amp;_nc_sid=7965db&amp;_nc_ohc=W7OCKGYCh54Q7kNvwHym8RL&amp;_nc_oc=AdnEUR9t2-o4WBRnenA3fH7tg-I-LklVkhqGRRvMTkHGCk8mxL1ZPonHGDzn6JEoRw4&amp;_nc_zt=23&amp;_nc_ht=scontent-nrt1-1.xx&amp;edm=AJfPMC4EAAAA&amp;_nc_gid=FALIYAFCBVtgGnPYOPpL7A&amp;oh=00_AfMZp-Q1oPVRVsgHbvTIFLyoNVbG0Xb2WDgTT56Vh80hGw&amp;oe=68484BB9">
                      </div>
                      <div class="relative flex-grow flex flex-col px-2">
                        <p class="flex-none flex text-lg overflow-hidden">
                          <span style="width: 70%;">AI 加漏斗 讓投放更高效 更省時！...</span>
                          <span class="w-1/3 mr-4">FaceBook Post</span>
                        </p>
                        <p class="flex-grow text-gray-500 overflow-hidden">1108961467897381</p>
                        <div class="flex-none flex">
                          <img src="/img/great.a251d02f.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">24</span>
                          <img src="/img/heart.8fdcbfc4.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">1</span>
                          <img src="/img/smile.65142fbd.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">0</span>
                          <img src="/img/cry.6e25808e.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">0</span>
                          <img src="/img/shock.bdb7c0e5.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">0</span>
                          <img src="/img/angry.1c0ad48e.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">0</span>
                          <div class="flex-grow text-right text-gray-500">
                            <span>2024/12/04</span>
                          </div>
                        </div>
                      </div>
                      <i class="absolute top-2 right-2 pi pi-times cursor-pointer"></i>
                    </div>
                  </div>
                  <div v-tippy="tooltipOptions" class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group">
                    <div class="relative flex justify-between p-1">
                      <div class="md:flex-shrink-0">
                        <img class="h-24 w-24 rounded-xl object-cover" src="https://scontent-nrt1-1.xx.fbcdn.net/v/t15.5256-10/469018299_2099756487132679_8282074920297271073_n.jpg?stp=dst-jpg_s130x130_tt6&amp;_nc_cat=109&amp;ccb=1-7&amp;_nc_sid=7965db&amp;_nc_ohc=W7OCKGYCh54Q7kNvwHym8RL&amp;_nc_oc=AdnEUR9t2-o4WBRnenA3fH7tg-I-LklVkhqGRRvMTkHGCk8mxL1ZPonHGDzn6JEoRw4&amp;_nc_zt=23&amp;_nc_ht=scontent-nrt1-1.xx&amp;edm=AJfPMC4EAAAA&amp;_nc_gid=FALIYAFCBVtgGnPYOPpL7A&amp;oh=00_AfMZp-Q1oPVRVsgHbvTIFLyoNVbG0Xb2WDgTT56Vh80hGw&amp;oe=68484BB9">
                      </div>
                      <div class="relative flex-grow flex flex-col px-2">
                        <p class="flex-none flex text-lg overflow-hidden">
                          <span style="width: 70%;">AI 加漏斗 讓投放更高效 更省時！...</span>
                          <span class="w-1/3 mr-4">FaceBook Post</span>
                        </p>
                        <p class="flex-grow text-gray-500 overflow-hidden">1108961467897381</p>
                        <div class="flex-none flex">
                          <img src="/img/great.a251d02f.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">24</span>
                          <img src="/img/heart.8fdcbfc4.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">1</span>
                          <img src="/img/smile.65142fbd.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">0</span>
                          <img src="/img/cry.6e25808e.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">0</span>
                          <img src="/img/shock.bdb7c0e5.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">0</span>
                          <img src="/img/angry.1c0ad48e.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">0</span>
                          <div class="flex-grow text-right text-gray-500">
                            <span>2024/12/04</span>
                          </div>
                        </div>
                      </div>
                      <i class="absolute top-2 right-2 pi pi-times cursor-pointer"></i>
                    </div>
                  </div>
                  <div v-tippy="tooltipOptions" class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group">
                    <div class="relative flex justify-between p-1">
                      <div class="md:flex-shrink-0">
                        <img class="h-24 w-24 rounded-xl object-cover" src="https://scontent-nrt1-1.xx.fbcdn.net/v/t15.5256-10/469018299_2099756487132679_8282074920297271073_n.jpg?stp=dst-jpg_s130x130_tt6&amp;_nc_cat=109&amp;ccb=1-7&amp;_nc_sid=7965db&amp;_nc_ohc=W7OCKGYCh54Q7kNvwHym8RL&amp;_nc_oc=AdnEUR9t2-o4WBRnenA3fH7tg-I-LklVkhqGRRvMTkHGCk8mxL1ZPonHGDzn6JEoRw4&amp;_nc_zt=23&amp;_nc_ht=scontent-nrt1-1.xx&amp;edm=AJfPMC4EAAAA&amp;_nc_gid=FALIYAFCBVtgGnPYOPpL7A&amp;oh=00_AfMZp-Q1oPVRVsgHbvTIFLyoNVbG0Xb2WDgTT56Vh80hGw&amp;oe=68484BB9">
                      </div>
                      <div class="relative flex-grow flex flex-col px-2">
                        <p class="flex-none flex text-lg overflow-hidden">
                          <span style="width: 70%;">AI 加漏斗 讓投放更高效 更省時！...</span>
                          <span class="w-1/3 mr-4">FaceBook Post</span>
                        </p>
                        <p class="flex-grow text-gray-500 overflow-hidden">1108961467897381</p>
                        <div class="flex-none flex">
                          <img src="/img/great.a251d02f.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">24</span>
                          <img src="/img/heart.8fdcbfc4.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">1</span>
                          <img src="/img/smile.65142fbd.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">0</span>
                          <img src="/img/cry.6e25808e.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">0</span>
                          <img src="/img/shock.bdb7c0e5.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">0</span>
                          <img src="/img/angry.1c0ad48e.svg" class="w-6 h-6">
                          <span class="pl-1 pr-4">0</span>
                          <div class="flex-grow text-right text-gray-500">
                            <span>2024/12/04</span>
                          </div>
                        </div>
                      </div>
                      <i class="absolute top-2 right-2 pi pi-times cursor-pointer"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="flex space-x-4 border-t pt-4">
              <div class="mb-4">
                <p class="text-lg font-bold text-primary mb-2">概況描述</p>
                <p class="text-gray-500 text-sm">目前廣告尚處於投遞初期的學習期階段，系統正針對不同受眾群與版位進行 A/B 測試，以找出最佳投遞組合。初步數據顯示，行動裝置用戶點擊率較高，但轉換率尚未穩定。現階段平均 CPC 為 NT$8.1，CPA 則約落在 NT$240，仍有優化空間。後續系統將逐步排除低互動的廣告組合，並集中資源於高表現版位。投遞策略將轉向以轉換優化（oCPA）為主，逐步壓低 CPA 並提升 ROAS（廣告投資報酬率）。</p>
              </div>
            </div>

            <div class="flex space-x-4 border-t pt-4">
              <div class="mb-4">
                <p class="text-lg font-bold text-primary mb-2">建議策略</p>
                <div class="space-y-2 text-gray-500 text-sm">
                  <label class="flex items-center space-x-2">
                    <input type="radio" name="strategy" value="keep" class="accent-primary" checked>
                    <span>維持目前策略</span>
                  </label>
                  <label class="flex items-center space-x-2">
                    <input type="radio" name="strategy" value="clicks" class="accent-primary">
                    <span>優化點擊率</span>
                  </label>
                  <label class="flex items-center space-x-2">
                    <input type="radio" name="strategy" value="reach" class="accent-primary">
                    <span>提高觸及人數</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <template #footer>
            <button type="submit" class="bg-green-500 text-white px-2 py-1 rounded">
              確定
            </button>
            <button @click="showReportDialog = false" class="bg-gray-200 text-gray-700 px-2 py-1 rounded ml-1">
              關閉
            </button>
          </template>
        </Dialog>
      </div>

      <div class="relative">
        <button @click="notificationList"
          class="text-gray-300 mr-4 hover:text-blue-300"
          :class="{'text-blue-300': notificationOpen}"
        >
          <i class="pi pi-bell" style="fontSize: 1.3rem"></i>
        </button>

        <!-- <div v-show="notificationOpen" @click="notificationList" class="fixed inset-0 h-full w-full z-10"
          style="display: none;"></div> -->

        <div v-show="notificationOpen"
          class="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-xl overflow-y-auto h-40 z-10"
          style="width: 20rem; display: none;">
          <span v-if="infoList.length == 0 && notificationOpen == true" class="h-40" style="line-height:160px; width:20rem; text-align:center;display: block;">讀取中</span>
          <template v-for="(item, index) in infoList">
            <span class="flex items-center px-4 py-3 text-gray-600 hover:bg-gray-100 -mx-2">
              <!-- <img class="h-8 w-8 rounded-full object-cover mx-1"
                src="http://placehold.it/100x100"
                alt="avatar"> -->
              <p class="text-sm mx-2">
                <!-- <span class="font-bold" href="#">Sara Salah</span> replied on the <span class="font-bold text-indigo-400"
                  href="#">Upload Image</span> artical . 2m -->
                <span class="font-bold">{{ item.info }}</span>
              </p>
            </span>
          </template>
          <!-- <a href="#" class="flex items-center px-4 py-3 text-gray-600 hover:bg-gray-100 -mx-2">
            <img class="h-8 w-8 rounded-full object-cover mx-1"
              src="http://placehold.it/100x100"
              alt="avatar">
            <p class="text-sm mx-2">
              <span class="font-bold" href="#">Slick Net</span> start following you . 45m
            </p>
          </a> -->
        </div>
      </div>

      <div class="relative">
        <button @click="dropdownOpen = ! dropdownOpen"
          class="text-gray-300 mr-4 hover:text-blue-300"
          :class="{'text-blue-300': dropdownOpen}"
        >
          <i class="pi pi-globe" style="fontSize: 1.3rem"></i>
        </button>

        <div v-show="dropdownOpen" @click="dropdownOpen = false" class="fixed inset-0 h-full w-full z-10"
          style="display: none;"></div>

        <div v-show="dropdownOpen" class="absolute right-0 mt-2 w-48 bg-white rounded-xl overflow-hidden shadow-xl z-10"
          style="display: none;">
          <a
            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
            :class="langUsing == 'zh-TW' ? 'bg-blue-100' : null"
            @click="langUse('zh-TW', 1)">繁體中文</a>
          <a
            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
            :class="langUsing == 'zh-CN' ? 'bg-blue-100' : null"
            @click="langUse('zh-CN', 1)">简体中文</a>
          <a
            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
            :class="langUsing == 'en-US' ? 'bg-blue-100' : null"
            @click="langUse('en-US', 1)">English</a>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
  import { watch } from 'vue'
  import axios from 'axios'
  import Qs from 'qs'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import Dialog from '@/components/Dialog.vue'

  export default {
    name: 'Header',
    components: {
      Loading,
      Dialog
    },
    props: {
      title: {
        type: String,
        default: '帳號資訊'
      },
      editPage: {
        type: Boolean
      },
      reportPage: {
        type: Boolean
      },
    },
    data() {
      return {
        allPageLoading: false,
        adSuggest: false,
        notificationOpen: false,
        dropdownOpen: false,
        showDialog: false,
        showReportDialog: false,
        infoList: [],
        langUsing: 'zh-TW'
      }
    },
    created() {
      // console.log(this.$route.params.id);
      console.log('header created');
      axios
        .post('https://test.autoturn.net/inside/api/get_lang.php', Qs.stringify({
          s_code: this.$route.params.id
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            this.langUsing = response.data.return_data
            this.langUse(response.data.return_data);
          }
        });


    },
    watch:{
      'locale': function(v){
        console.log('header:'+v);
        this.$emit('childLang', v);
      }
    },
    methods: {
      langUse(v, active){
        console.log('langUse');
        console.log(v);
        console.log(active);

        this.langUsing = v;
        this.$emit('childLang', v);

        axios
          .post('https://test.autoturn.net/inside/api/data/lang_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            lang: v
          }))
          .then((response) => {
            // if(response.data.status == 'success'){
              console.log('response.data');
              console.log(response.data);

              this.dropdownOpen = false;

              if(typeof active != 'undefined'){
                this.allPageLoading = true
                window.location.reload();
              }
            // }
          });


      },
      notificationList(){
        console.log('notificationList');
        if(this.notificationOpen == false){
          console.log('false');
          let type = this.$route.params.type;
          axios
            .post('https://test.autoturn.net/inside/api/notification_system.php', Qs.stringify({
              s_code: this.$route.params.id,
              type: type
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                this.infoList = response.data.return_data

                this.notificationOpen = true;
              }
            });
        } else {
          console.log('true');
          this.notificationOpen = false;
        }

      }
    }
  }
</script>
<style lang="">

</style>